import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

import LandingPage  from "./pages/LandingPage";
import Landing from "./pages/NewLandingPage";

import LoginPage  from "./pages/auth/LoginPage";
import SignupPage from "./pages/auth/SignupPage";
import KYCPage   from "./pages/auth/KYCPage";
import ResetPasswordPage from "./pages/auth/ResetPasswordPage";

import MemberLayout    from "./components/layout/MemberLayout";
import AdminLayout     from "./components/layout/AdminLayout";

import MemberDashboard from "./pages/member/DashboardPage";
import SavingsPage     from "./pages/member/SavingsPage";
import LoansPage       from "./pages/member/LoansPage";
import ApplyLoanPage   from "./pages/member/ApplyLoanPage";
import ActivityPage    from "./pages/member/ActivityPage";
import MembersPage     from "./pages/member/MembersPage";
import MemberSavingTarget from "./pages/member/MemberTargetSavingsPage";
import ProfilePage     from "./pages/member/ProfilePage";

import AdminOverview     from "./pages/admin/OverviewPage";
import AdminMembers      from "./pages/admin/MembersPage";
import AdminContribution from "./pages/admin/ContributionReconcilePage";
import AdminMemberDetail from "./pages/admin/MemberDetailPage";
import AdminMemberWithdraw from "./pages/admin/MemberWithdrwalDetailsPage";
import AdminLoans        from "./pages/admin/LoansPage";
import AdminWithdrawal   from "./pages/admin/WithdrawalsPage";
import AdminLoanDisburse from "./pages/admin/LoanDisbursalPage";
import AdminReports      from "./pages/admin/ReportsPage";
import AdminActivity     from "./pages/admin/ActivityPage";
import AdminSettings     from "./pages/admin/SettingsPage";
import MemberReconciliationDetailsPage from "./pages/admin/ReconciliationDetailsPage";

function Guard({ children, adminOnly=false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="flex items-center justify-center min-h-screen text-slate-500 text-sm">Loading…</div>;
  if (!user) return <Navigate to="/home" replace/>;
  if (user.kyc_status === "pending") return <Navigate to="/kyc" replace/>;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace/>;
  return <>{children}</>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/"    element={<Landing />}/>
      <Route path="/login"  element={<LoginPage/>}/>
      <Route path="/signup" element={<SignupPage/>}/>
      <Route path="/kyc"    element={<KYCPage/>}/>
      <Route path="/resetpassword" element={<ResetPasswordPage/>} />
      <Route path="/home"    element={<Landing />}/>

      <Route path="/" element={<Guard><MemberLayout/></Guard>}>
        <Route index                element={<MemberDashboard/>}/>
        <Route path="savings"       element={<SavingsPage/>}/>
        <Route path="loans"         element={<LoansPage/>}/>
        <Route path="loans/apply"   element={<ApplyLoanPage/>}/>
        <Route path="activity"      element={<ActivityPage/>}/>
        <Route path="members"       element={<MembersPage/>}/>
        <Route path="settarget/:id" element={<MemberSavingTarget/>}/>
        <Route path="profile"       element={<ProfilePage/>}/>
      </Route>

      <Route path="/admin" element={<Guard adminOnly><AdminLayout/></Guard>}>
        <Route index                element={<AdminOverview/>}/>
        <Route path="members"       element={<AdminMembers/>}/>
        <Route path="members/:id"   element={<AdminMemberDetail/>}/>
        <Route path="memberwithdraw/:id"   element={<AdminMemberWithdraw />}/>
        <Route path="loans"         element={<AdminLoans/>}/>
        <Route path="withdrawals"   element={<AdminWithdrawal />}/>
        <Route path="loans/:id"     element={<AdminLoanDisburse />} />
        <Route path="contribution"  element={<AdminContribution />} />
        <Route path="contribution/:id" element={<MemberReconciliationDetailsPage />} />
        <Route path="reports"       element={<AdminReports/>}/>
        <Route path="activity"      element={<AdminActivity/>}/>
        <Route path="settings"      element={<AdminSettings/>}/>
      </Route>

      <Route path="*" element={<Navigate to={user?.role==="admin"?"/admin":"/"} replace/>}/>
    </Routes>
  );
}

export default function App() {
  return <AuthProvider><AppRoutes/></AuthProvider>;
}
